import { render, staticRenderFns } from "./SectionDef.vue?vue&type=template&id=0be6b27e&scoped=true&"
import script from "./SectionDef.vue?vue&type=script&lang=js&"
export * from "./SectionDef.vue?vue&type=script&lang=js&"
import style0 from "./SectionDef.vue?vue&type=style&index=0&id=0be6b27e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6b27e",
  null
  
)

component.options.__file = "SectionDef.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBreadcrumbsItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBreadcrumbs,
  VBreadcrumbsItem,
  VContainer,
  VIcon,
  VImg,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
